import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';
import { parseUrlParam } from '~/components/Filter';
import { ContentKind } from '~/generated/graphql';

const KIND_SCHEMA = z.array(
  z.enum([
    ContentKind.App,
    ContentKind.Image,
    ContentKind.Overlay,
    ContentKind.Pdf,
    ContentKind.Powerpoint,
    ContentKind.Video,
  ]),
);
const TAG_SCHEMA = z.array(z.string());

export const getContentFiltersParams = (searchParams: URLSearchParams) => ({
  kind: parseUrlParam(
    () => KIND_SCHEMA.parse(JSON.parse(searchParams.get('kind') || '[]')),
    'kind',
  ),
  tags: parseUrlParam(() => TAG_SCHEMA.parse(JSON.parse(searchParams.get('tags') || '[]')), 'tags'),
});

export const useFilterParams = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => getContentFiltersParams(searchParams), [searchParams]);
};
